<template>
  <li>
    <div
      class="cursorPointer"
      @click="toggle(node)"
    >
      <span class="mr-1 open-close">[{{ isOpen ? '-' : '+' }}]</span>

      <!-- Show folder name -->
      <font-awesome-icon
        icon="folder"
        class="mr-1"
      />
      <span
        class="folder-label cursorPointer"
        :class="{ selected: isSelectedFolder(node) }"
      >
        {{ node.title }}
        <span v-if="showQuestionsCount">
          ({{ questionsCount }})
        </span>
        <span v-if="isFolderSelect">
          ({{ folderChildrenCount }})
        </span>
      </span>
    </div>

    <!-- Show questions titles -->
    <div v-if="isOpen">
      <ul v-if="showQuestions">
        <div
          v-for="question in node.killer_questions_templates"
          :key="question.id"
        >
          <font-awesome-icon
            icon="file"
            class="mr-2 file-icon"
          />
          <span
            class="question-label"
            :class="{ cursorPointer: isQuestionSelect, selected: isSelectedQuestion(question) }"
            @click="selectQuestion(question)"
          >{{ question.text }}</span>
        </div>
      </ul>

      <!-- Recurse -->
      <ul v-if="node.killer_question_children && node.killer_question_children.length">
        <FolderNode
          v-for="child in node.killer_question_children"
          :key="child.id"
          :node="child"
          :show-questions="showQuestions"
          :is-folder-select="isFolderSelect"
          :select-folder="selectFolder"
          :is-selected-folder="isSelectedFolder"
          :is-question-select="isQuestionSelect"
          :select-question="selectQuestion"
          :is-selected-question="isSelectedQuestion"
          :show-questions-count="showQuestionsCount"
        />
      </ul>
    </div>
  </li>
</template>

<script>
function recursiveCount(node) {
  let count = node.killer_questions_templates.length;
  for(let child of node.killer_question_children) {
    count += recursiveCount(child);
  }

  return count;
}

export default {
  name: "FolderNode",
  props: {
    node: {
      type: Object,
      default: () => {}
    },
    showQuestions: {
      type: Boolean,
      default: false
    },
    isFolderSelect: {
      type: Boolean,
      default: false
    },
    selectFolder: {
      type: Function,
      default: () => {}
    },
    isSelectedFolder: {
      type: Function,
      default: () => {}
    },
    isQuestionSelect: {
      type: Boolean,
      default: false
    },
    selectQuestion: {
      type: Function,
      default: () => {}
    },
    isSelectedQuestion: {
      type: Function,
      default: () => {}
    },
    showQuestionsCount: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    questionsCount() {
      return recursiveCount(this.node);
    },
    folderChildrenCount() {
      return this.node.killer_question_children.length;
    }
  },
  methods: {
    toggle(node) {
      this.isOpen = !this.isOpen;
      if(this.isFolderSelect) {
        this.selectFolder(node);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  li {
    list-style-type: none;
  }

  .folder-label,
  .question-label {
    font-size: 0.9rem;
  }

  .cursorPointer {
    cursor: pointer;
  }

  .file-icon {
    color: gray;
  }

  .selected {
    font-weight: 600;
    text-decoration: underline;
  }

  .open-close {
    float: left;
    width: 20px;
  }
</style>